import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { SkipLink } from '../skip-link/SkipLink';
import type { Link } from '../types';

import styles from './skip-links.scss';

interface SkipLinksProps {
  links: Link[];
}

export const SkipLinks = ({ links }: SkipLinksProps) => (
  <LinkList
    links={links}
    Item={SkipLink}
    className={styles.skip}
    children={undefined}
  />
);
